// Confetes da comemoração (AC-031) — só CSS, sem biblioteca. Respeita "reduzir movimento".
import { useMemo, type CSSProperties } from 'react';

const COLORS = ['#4ADE80', '#FFC83D', '#FB923C', '#60A5FA', '#F87171', '#F4F4F5'];

export function Confetti({ pieces = 70 }: { pieces?: number }) {
  const bits = useMemo(
    () =>
      Array.from({ length: pieces }, (_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 0.6,
        duration: 1.6 + Math.random() * 1.6,
        drift: (Math.random() - 0.5) * 120,
        spin: 360 + Math.random() * 720,
        color: COLORS[i % COLORS.length],
        w: 5 + Math.random() * 5,
        h: 8 + Math.random() * 8,
        round: Math.random() < 0.3,
      })),
    [pieces]
  );
  return (
    <div className="confetti" aria-hidden="true" data-testid="confetti">
      {bits.map((b, i) => (
        <span
          key={i}
          className="confetti__bit"
          style={
            {
              left: `${b.left}%`,
              width: b.w,
              height: b.round ? b.w : b.h,
              borderRadius: b.round ? '50%' : 2,
              background: b.color,
              animationDelay: `${b.delay}s`,
              animationDuration: `${b.duration}s`,
              '--drift': `${b.drift}px`,
              '--spin': `${b.spin}deg`,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
